import AI_helperGroupClass from "./ai_helperGroupClass";
import AI_helperItemClass from "./ai_helperItemClass";
import ai_helper from "../ai_helper";

let AI_helperComplectClass = function(o, index, CRM) {
	this.type = 'complect';
	this.crm = CRM;
	this.index = index;
	this.folderURL = CRM.folderURL;
	this.id = 0;
	this.hh = 'ИНТЕЛЛЕКТУАЛЬНЫЙ РАСЧЕТ ЗАКАЗА';
	this.hh_add = '';
	this.debug = CRM.debug;
	this.service_debug = CRM.service_debug;
	this.user = CRM.user;
	this.sale_exceptions = CRM.sale_exceptions;
	this.sale_exceptions_cashback = CRM.sale_exceptions_cashback;
	this.discount_pics_ids = CRM.discount_pics_ids;
	this.infoFields={};
	this.exceptions = CRM.exceptions;
	this.profile = CRM.profile;
	this.groups = {};
	this.goods = {};
	this.dom = null;
	this.containers = {
		handle: null,
		header: null,
		items: null,
		total: null,
	};
	this.calculated=false;
	this.full = false;
	this.table_goods = null;
	this.sale = 0;
	this.wholeSum = 0;
	//this.makePost = CRM.makePost;
	this.minimized = false;
	this.controls = {
		selector: null,
		count: null,
		square: null,
		count_but: null,
		square_but: null,
		minimize: null,
		destroy: null,
	};
	this.header_text = null;
	this.basket_sum = 0;
	this.salesum = 0;
	this.saletotalsum = 0;
	this.cashbackSum = 0;
	this.hide_squares = [20000221, 30003607];
	this.enableFullfill = false; // 'это включение опии "Дополнить комплект", должна активироваться только для указанных пользователей!
	this.id_good = 0;
	this.basket_sum = 0;
	this.groups_bubles_data = [];

	this.next_sum = 0;
	this.next_sale = 0;

	this.groupMinimized = false;

	this.calcCount = 100;
	this.squareCount = 100;
	this.inBusket = false;
	this.square = false;

	this.date = null;

	this.aiCalculatedSale = 0;

	this.check1 = false;
	this.check2 = false;

	this.initGroupsBubbleData = function(data) {
		this.groups_bubles_data = data;
		//console.log('groups_bubles_data', this.groups_bubles_data);
		for (let key in this.groups) {
			if (Object.prototype.hasOwnProperty.call(this.groups, key)) {
				let group = this.groups[key];
				if (group) {
					if (this.groups_bubles_data) {
						group.initBubbleData(this.groups_bubles_data[group.id]);
					}
				}
			}
		}
	};
	this.release = function () {
		let groups = [];
		let goods = [];
		for (let k in this.groups) {
			if (Object.prototype.hasOwnProperty.call(this.groups, k)) {
				let group = this.groups[k];
				groups[groups.length] = group.release();
			}
		}
		for (let k in this.goods) {
			if (Object.prototype.hasOwnProperty.call(this.goods, k)) {
				let good = this.goods[k];
				goods[goods.length] = good.release();
			}
		}
		return {
			id: this.id,
			hh: this.hh,
			hh_add: this.hh_add,
			index: this.index,
			respond: this.respond,
			sale_exceptions: this.sale_exceptions,
			sale_exceptions_cashback: this.sale_exceptions_cashback,
			discount_pics_ids: this.discount_pics_ids,
			exceptions: this.exceptions,
			sale: this.sale,
			wholeSum: this.wholeSum,
			groups: groups,
			goods: goods,
			restore: true,
			id_good: this.id_good,
			minimized: this.minimized,
			groupMinimized: this.groupMinimized,
			calcCount: this.calcCount,
			squareCount: this.squareCount,
            inBusket: this.inBusket,
			date: this.date,
            aiCalculatedSale: this.aiCalculatedSale,
			square: this.square,
			check1: this.check1,
			check2: this.check2
		}
	};
	this.init = function (o) {
		if (typeof o !== "undefined" && o != null) {
			if (typeof o.restore !== "undefined")
				this.init_restore(o);
			else
				this.init_new(o);
		}
	};
	this.init_restore = function (o) {
		// console.log('RESTORE COMPL');
		if (o.id)this.id = o.id;
		if (o.hh)this.hh = o.hh;
		if (o.hh_add)this.hh_add = o.hh_add;
		if (o.index)this.index = o.index;
		if (o.respond)this.respond = o.respond;
		if (o.sale_exceptions)this.sale_exceptions = o.sale_exceptions;
		if (o.sale_exceptions_cashback)this.sale_exceptions_cashback = o.sale_exceptions_cashback;
		if (o.discount_pics_ids) this.discount_pics_ids = o.discount_pics_ids;
		if (o.exceptions) this.exceptions = o.exceptions;
		if (o.sale) this.sale = o.sale;
		if (o.wholeSum) this.wholeSum = o.wholeSum;
		if (o.id_good) this.id_good = o.id_good;
		if (o.minimized) this.minimized = o.minimized;
		if (o.groupMinimized) this.groupMinimized = o.groupMinimized;

		if (o.calcCount) this.calcCount = o.calcCount;
		if (o.squareCount) this.squareCount = o.squareCount;

		if (o.inBusket) this.inBusket = o.inBusket;
		if (o.date) this.date = o.date;
		if (o.square) this.square = o.square;

		if (o.check1) this.check1 = o.check1;
		if (o.check2) this.check2 = o.check2;

		let self = this;
		let groups_request = [];
		if (o.groups.length > 0) {
			for (let key in o.groups) {
				if (Object.prototype.hasOwnProperty.call(o.groups, key)) {
					let val = o.groups[key];
						// console.log('GROUP',val);
					this.groups[key] = new AI_helperGroupClass(val, this);
					groups_request.push({id: this.groups[key].id, id_good_inet: this.groups[key].id_good_inet, gids: this.groups[key].gids});
					this.groups[key].append(this.table_goods);
				}
			}
		}
		self.get_groups_bubbles(groups_request, function(data){self.initGroupsBubbleData(data);});
		if (o.goods.length > 0) {
			// self.table_goods.appendChild(self.getAddHeaderDom());
			for (let key in o.goods) {
				if (Object.prototype.hasOwnProperty.call(o.goods, key)) {
					let val = o.goods[key];
					let good = new AI_helperItemClass(val, self, function () {
						self.check_complect();
					},null);
					if (good.enableStock) {
						self.goods[good.id] = good;
						// good.controls.del.style.display = 'none';
						self.goods[good.id].append(self.table_goods);
					}
				}
			}
		}
		self.check_complect();
		// self.controls.calculated.style.display = 'block';
		self.calculated = true;
	};
	this.init_new = function () {
		if (o.id) this.id = o.id;
		if (o.folder) this.hh = o.folder;
		if (o.alt_folder) this.hh_add = o.alt_folder;
		if (o.name) this.hh_add = o.name;
		if (o.id_good) this.id_good = o.id_good;
	};
	this.get_groups_bubbles = function(data, cb) {
		let self = this;
		this.crm.makePost('aiHelper', 'get_groups_bubbles', {groups:data}, null, function (respond) {
			if (respond.status === 'OK') {
				if (cb) cb(respond.data);
                self.crm.check_complect();
			}
		});
	};
	this.renderFields=function(model,value) {
		console.log(model, value)
		for(let key in this.infoFields) {
			if (Object.prototype.hasOwnProperty.call(this.infoFields, key)) {
				let block = this.infoFields[key];
				if (block[model]) {
					// if (typeof value === 'string') {
					// 	block[model].innerHTML = value;
					// } else {
					// 	block[model].innerHTML = window.number_format(value, 2, '.', ' ');
					// }
				}
			}
		}
	};
	this.destroy = function () {
		delete (this.dom);
		this.dom = null;
		delete (this.crm.complects[this.index]);
		this.check_complect();
		//console.log(this.crm.complects);
		this.crm.render();
	};
	this.changeMinimize = function() {
		// if (this.minimized) {
		// 	this.crm.minimize_complects();
		// 	this.maximize();
		// } else {
		// 	this.minimize();
		// }
		// this.crm.updateComplectsInfo();
	};
	this.minimize = function () {
		// if (this.containers.header) this.containers.header.style.display = 'none';
		// if (this.containers.items) this.containers.items.style.display = 'none';
		// if (this.containers.total) this.containers.total.style.display = 'none';
		// if (this.controls.selector) this.controls.selector.style.display = 'none';
		// this.controls.minimize.innerHTML = 'Развернуть';
		// this.minimized = true;
	};
	this.maximize = function () {
		// if (this.calculated) {
		// 	if (this.containers.items) this.containers.items.style.display = 'block';
		// 	if (this.containers.total) this.containers.total.style.display = 'block';
		// }
		// if (this.containers.header) this.containers.header.style.display = 'block';
		// if (this.controls.selector) this.controls.selector.style.display = 'block';
		// this.controls.minimize.innerHTML = 'Свернуть';
		// this.minimized = false;
	};
	this.getSumBySale = function (sale, lim) {
		let ret = 0;
		let maxV = 0;
		let maxK = 0;
		if (lim) {
			for (let k in lim) {
				if (Object.prototype.hasOwnProperty.call(lim, k)) {
					let v = lim[k];
					k = parseInt(k);
					if (k === sale) {
						ret = v;
						break;
					} else {
						if (v > maxV) maxV = v;
						if (k > maxK) maxK = k;
					}
				}
			}
		}
		if (ret === 0) {
			if (sale > 0)
				ret = maxV;
			if (sale > maxK && sale < 30)
				sale = 30;
		}
		ret = ret * 1000;
		return {sale: sale, sum: ret};
	};
	this.getSaleBySum = function (sum, lim) {
		let ret = 0;
		let max = 0;
		let prevV = 0;
		if (lim) {
			for (let k in lim) {
				if (Object.prototype.hasOwnProperty.call(lim, k)) {
					let v = lim[k];
					ret = parseInt(k);
					let vv = v * 1000;
					if (prevV < sum && vv >= sum){
						break;
					}
					if (v > max) max = v;
					prevV = v;
				}
			}
		}
		return {sale: ret, sum: sum};
	};
	this.getNextBySale = function (sale, lim) {
		let self = this;
		let ret = {sale: 0, sum: 0};
		let prevV = 0;
		let maxV = 0;
		let maxK = 0;
		if (lim) {
			for (let k in lim) {
				if (Object.prototype.hasOwnProperty.call(lim, k)) {
					let v = lim[k];
					k = parseInt(k);
					if (k > sale) {
						ret = {sale: k, sum: prevV};
						break;
					}
					if (v > maxV) maxV = v;
					if (k > maxK) maxK = k;
					prevV = v * 1000;
				}
			}
		}
		maxV = maxV * 1000;
		if (ret.sum === 0) {
			if (sale > 0) ret.sum = maxV;
			if (sale >= maxK) {
				if (self.full) ret.sale = 35;
				else {
					ret.sale = 30;
					ret.sum = 0;
				}
			}
		}
		if (sale >= 35) ret = {sale: 0, sum: 0};
		return ret;
	};
	this.get_basket_sum = function () {
		let basket_sum = 0;
		for (let k in this.groups) {
			if (Object.prototype.hasOwnProperty.call(this.groups, k)) {
				let v = this.groups[k];
				basket_sum += v.sum;
			}
		}
		for (let k in this.goods) {
			// if (Object.prototype.hasOwnProperty.call(this.goods, k)) {
			if (Object.prototype.hasOwnProperty.call(this.goods, k) && this.goods[k].added) { // Кнопка "Добавить/отменить"
				let v = this.goods[k];
				basket_sum += v.sum;
			}
		}
		this.basket_sum = basket_sum;
		return basket_sum;
	};
	this.getAddHeaderDom = function () {
		// let tr =  new HtmlDom(additionalGroupTemplate, {}, this);
		// return tr;
	};
	this.check_complect = function () {
		//	console.log('this.user.sum',this.user.sum);
		this.crm.check_complect(this.user.sum);
	};
	this.check_complect_exe = function (fs) {
		this.user = this.crm.user;

		if (!this.user.cid) return false;
		if (!this.user.sum) this.user.sum = 0;
		if (!this.user.sale) this.user.sale = 0;
		if (!this.user.max_sum) this.user.max_sum = 0;
		this.sale = this.user.sale;
		this.full = true;
		// if (this.basket_sum >0) {
		// 	this.calculated = true;
		// 	// if (this.controls.info) this.controls.info.style.display = 'none';
		// 	// if (this.controls.calculated) this.controls.calculated.style.display = 'block';
		// } else {
		// 	// this.calculated = false;
		// 	// if (this.controls.info) this.controls.info.style.display = 'table-row';
		// 	// if (this.controls.calculated) this.controls.calculated.style.display = 'none';
		// }

		if (this.groups.length > 0) {
            this.calculated = true;
		} else {
            this.calculated = false;
		}

		for (let k in this.groups) {
			if (Object.prototype.hasOwnProperty.call(this.groups, k)) {
				let v = this.groups[k];
				// if (v.restAmount > 0 && v.amount > 0) this.full = false;
				if (v.restAmount > 0 && v.amount > 0 && !v.exclude) {
					this.full = false;
				}
			}
		}
		let basket_sum = this.basket_sum;

		if (this.inBusket)
			this.fullsum = this.user.sum + fs.fullsum;
		else this.fullsum = this.user.sum + fs.fullsumPreview;

		// console.log(this)

		let lim = [];
		//this.user.sale_limits.main;
		if (this.full)
			lim = this.user.sale_limits.full;
		else
			lim = this.user.sale_limits.main;
		this.sale = this.getSaleBySum(this.fullsum, lim).sale;
		let next = this.getNextBySale(this.sale, lim);

        let next_sum;
		if (this.inBusket)
			next_sum = next.sum - this.user.sum - fs.fullsum;
		else next_sum = next.sum - this.user.sum - fs.fullsumPreview;

		let next_sale = next.sale;

		this.next_sum = next_sum;
		this.next_sale = next_sale;
		if (this.full) {
			let curr = this.getSumBySale(this.sale, lim);
			if (curr.sum <= this.fullsum && this.sale >= 30) {
				this.sale = 35;
				next_sale = 0;
			} else
				this.sale = curr.sale;
		}
		let basket_sale_sum = 0;
		let cashbackSum = 0;
		this.wholeSum = basket_sum;
		//console.log('COMPLECT FULLSUM',  this.fullsum);
		for (let k in this.groups) {
			if (Object.prototype.hasOwnProperty.call(this.groups, k)) {
				let v = this.groups[k];
				//v.setSale(this.sale, this.wholeSum);
				//console.log('SALE', this.sale);
				v.setSale(this.sale, this.fullsum);
				cashbackSum += v.cashbackSum;
				basket_sale_sum += v.sale_sum;
			}
		}
		for (let k in this.goods) {
			if (Object.prototype.hasOwnProperty.call(this.goods, k) ) {
			// if (Object.prototype.hasOwnProperty.call(this.goods, k) && this.goods[k].added) { //Реализация кнопки "Добавить/отменить"
				let v = this.goods[k];
				//v.setSale(this.sale, this.wholeSum);
				v.setSale(this.sale, this.fullsum);
				if (this.goods[k].added) { //Реализация кнопки "Добавить/отменить"
					cashbackSum += v.cashbackSum;
					basket_sale_sum += v.sale_sum;
				}
			}
		}
		let total_sale_sum = basket_sum - basket_sale_sum;
		cashbackSum = Math.round(cashbackSum * 100) / 100;
		basket_sum = Math.round(basket_sum * 100) / 100;
		basket_sale_sum = Math.round(basket_sale_sum * 100) / 100;
		total_sale_sum = Math.round(total_sale_sum * 100) / 100;
		this.cashbackSum = cashbackSum;
		this.salesum = total_sale_sum;
		this.saletotalsum = basket_sale_sum;

		// console.log('comp', fs, this.fullsum, this.user.sum)

		// console.log('sale', this.sale, this.next_sale, this.next_sum)

		//if (this.containers.total) this.containers.total.style.display='block';
		// this.renderFields('sum',basket_sum);
		// this.renderFields('sale',this.sale);
		// this.renderFields('sale_sum',total_sale_sum);
		// this.renderFields('total',basket_sale_sum);
		// if (this.sale === 35) {
		// 	this.renderFields('next_sale','<span style="color:red;">У Вас максимальная скидка!!!</span>');
		// 	this.renderFields('next_sum','');
		// } else if (next_sum > 0) {
		// 	this.renderFields('next_sale','Для получения скидки <span style="color:red;">' + next_sale + '%</span> необходимо увеличить заказ на сумму, руб.');
		// 	this.renderFields('next_sum',next_sum);
		// } else {
		// 	this.renderFields('next_sale','Для получения скидки <span style="color:red;">' + next_sale + '%</span> необходимо Заказать полный комплект');
		// 	this.renderFields('next_sum','');
		// }
		return true;
	};
	this.parts = function (id, calcCount, squareCount, is_square, done) {
		if (this.table_goods) {
			// this.table_goods.innerHTML='';
		}
		let self = this;
		let data = {id: id, count: 0, square: 0};
		// if (self.controls.count && self.controls.square)
		if (is_square) {
			data = {id: id, count: 0, square: squareCount};
			this.square = true;
		} else
			data = {id: id, count: calcCount, square: 0};
		this.crm.makePost('aiHelper', 'info', data, null, function (respond) {
			if (respond.status === 'OK') {
				respond = respond.data;
				self.respond = respond;
				if (respond.discount_pics_ids) self.discount_pics_ids = respond.discount_pics_ids;
				if (respond.sale_exceptions) self.sale_exceptions = respond.sale_exceptions;
				if (respond.sale_exceptions_cashback) self.sale_exceptions_cashback = respond.sale_exceptions_cashback;
				if (respond.exceptions) self.exceptions = respond.exceptions;
				let groups_request = [];
				// console.log(respond)
				if (respond.groups.length > 0) {
					for (let key in respond.groups) {
						if (Object.prototype.hasOwnProperty.call(respond.groups, key)) {
							let val = respond.groups[key];
							self.groups[key] = new AI_helperGroupClass(val, self);
							groups_request.push({id: self.groups[key].id, id_good_inet: self.groups[key].id_good_inet, gids: self.groups[key].gids});
							self.groups[key].append(self.table_goods);
						}
					}
				}

				if (respond.goods.length > 0) {
					// self.table_goods.appendChild(self.getAddHeaderDom());
					for (let key in respond.goods) {
						if (Object.prototype.hasOwnProperty.call(respond.goods, key)) {
							let val = respond.goods[key];
							let good = new AI_helperItemClass(val, self, function () {
								self.check_complect();
							},null);
							if (good.enableStock) {
								self.goods[good.id] = good;
								// good.controls.del.style.display = 'none';
								// self.goods[good.id].append(self.table_goods);
							}
						}
					}
				}
				self.calculated = true;
				// self.maximize();
				self.check_complect();

				self.date = new Date();

				self.get_groups_bubbles(groups_request, function(data){
					self.initGroupsBubbleData(data);
					if (done) done();
				});

			} else {
				//self.container.innerHTML='';
				console.log('ERROR: ');
				console.log(respond);
			}
		});
	};
	this.countCalc = function(id, count){
		// let id = this.id;
		// let val = parseInt(this.controls.count.value);
		if (count > 0)
			this.parts(id, false);
		else
			alert('Значение не может быть меньше Единицы!');
	};
	this.squareCalc = function(){
		let id = this.id;
		let val = parseInt(this.controls.square.value);
		if (val > 0)
			this.parts(id, true);
		else
			alert('Значение не может быть меньше Единицы!');
	};
	this.zeroCalc = function(){
		let id = this.id;
		this.controls.count.value = 0;
		this.controls.square.value = 0;
		if (this.controls.selector) id = this.controls.selector.value;
		this.parts(id, false);
	};
	this.fullfillSet = function() {
		let set = this;

		for (let group in set.groups) {
			set.groups[group].event();
			if (!(set.groups[group].emptyBubbleData && set.groups[group].ids.length == 0) && set.groups[group].restAmount > 0) {
				let difference = set.groups[group].restAmount;
				let limit = 10;

				// eslint-disable-next-line no-inner-declarations
				function check() {
					limit--;
					function addNew() {
						if (set.groups[group].bubbleItems.length > 0) {
							for (let item in set.groups[group].bubbleItems) {
								if (set.groups[group].bubbleItems[item] && set.groups[group].bubbleItems[item].enableStock && difference > 0 && !set.groups[group].items[set.groups[group].bubbleItems[item].id]) {
									if (set.groups[group].bubbleItems[item].gdsInStock >= difference) {
										let count = difference / set.groups[group].bubbleItems[item].package ^ 0;
										if (difference - (count * set.groups[group].bubbleItems[item].package) != 0) count += 1
										difference = difference - (count * set.groups[group].bubbleItems[item].package);
										set.groups[group].items[set.groups[group].bubbleItems[item].id] = new AI_helperItemClass(set.groups[group].bubbleItems[item], ai_helper);
										set.groups[group].items[set.groups[group].bubbleItems[item].id].autoAdded = true;
										set.groups[group].items[set.groups[group].bubbleItems[item].id].count += count * set.groups[group].items[set.groups[group].bubbleItems[item].id].package;
										set.groups[group].items[set.groups[group].bubbleItems[item].id].sum = set.groups[group].items[set.groups[group].bubbleItems[item].id].count * set.groups[group].items[set.groups[group].bubbleItems[item].id].priceRub;
										set.groups[group].items[set.groups[group].bubbleItems[item].id].setDomValues();
										//set.groups[group].getActualAmount();
										set.groups[group].ids.push(set.groups[group].bubbleItems[item].id);
									} else {
										let stock = set.groups[group].bubbleItems[item].gdsInStock / set.groups[group].bubbleItems[item].package ^ 0;
										stock = stock * set.groups[group].bubbleItems[item].package;
										difference = difference - stock;
										set.groups[group].items[set.groups[group].bubbleItems[item].id] = new AI_helperItemClass(set.groups[group].bubbleItems[item], ai_helper);
										set.groups[group].items[set.groups[group].bubbleItems[item].id].autoAdded = true;
										set.groups[group].items[set.groups[group].bubbleItems[item].id].count = stock;
										set.groups[group].items[set.groups[group].bubbleItems[item].id].sum = set.groups[group].items[set.groups[group].bubbleItems[item].id].count * set.groups[group].items[set.groups[group].bubbleItems[item].id].priceRub;
										set.groups[group].items[set.groups[group].bubbleItems[item].id].setDomValues();
										set.groups[group].items[set.groups[group].bubbleItems[item].id].empty = true;
										//set.groups[group].getActualAmount();
										set.groups[group].ids.push(set.groups[group].bubbleItems[item].id);
									}
								}
							}
							set.groups[group].getActualAmount();
						}
					}

					if (Object.keys(set.groups[group].items).length != 0) {
						for (let item in set.groups[group].items) {
							if (difference > 0) {
								if (set.groups[group].items[item].gdsInStock >= difference && !set.groups[group].items[item].empty) {
									let count = difference / set.groups[group].items[item].package ^ 0;
									if (difference - (count * set.groups[group].items[item].package) != 0) count += 1
									difference = difference - (count * set.groups[group].items[item].package);
									set.groups[group].items[item].count += count * set.groups[group].items[item].package;
									set.groups[group].items[item].autoAdded = true;
									set.groups[group].items[item].sum = set.groups[group].items[item].count * set.groups[group].items[item].priceRub;
									//set.groups[group].getActualAmount();
								} else {
									let stock = set.groups[group].items[item].gdsInStock / set.groups[group].items[item].package ^ 0;
									stock = stock * set.groups[group].items[item].package;
									difference = (difference + set.groups[group].items[item].count) - stock;
									set.groups[group].items[item].count = stock;
									set.groups[group].items[item].autoAdded = true;
									set.groups[group].items[item].sum = set.groups[group].items[item].count * set.groups[group].items[item].priceRub;
									//set.groups[group].getActualAmount();
									set.groups[group].items[item].empty = true;
								}

							}
						}
						set.groups[group].getActualAmount();

						if (difference > 0 && limit > 0) {
							//console.log('diff1', difference)
							addNew()
						}
					} else if (limit > 0) {
						//console.log('diff2', difference)
						addNew()
					}

					if (difference > 0 && limit > 0) {
						check();
					}
				}

				if (difference > 0 && limit > 0) {
					check();
				}
			}
		}

		set.full = true;
	};

	this.init(o);
};//class
export default AI_helperComplectClass;
